// extracted by mini-css-extract-plugin
module.exports = {"dynItem":"dynItem_39R7r","img":"img_jWC8_","tag":"tag_hPBAe","circle":"circle_1qQza","fixItem":"fixItem_qpch7","title":"title_1A1Tk"};